'use strict';

var debugMode = module.exports = {};

debugMode._debug = undefined;

debugMode.get = function () {
  if (debugMode._debug !== undefined) {
    return debugMode._debug;
  }
  // On startup honour URL param first
  if (/trackdebug=1/.test(window.location)) return true;
  if (/trackdebug=0/.test(window.location)) return false;
  // Then check local storage
  debugMode._debug = debugMode._localStorageWrapper('getItem', 'trackerDebug') === 'true';
  return debugMode._debug;
};

debugMode.set = function () {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (value === null) {
    value = debugMode.get();
  }
  if (value) {
    debugMode._localStorageWrapper('setItem', 'trackerDebug', value);
  } else {
    debugMode._localStorageWrapper('removeItem', 'trackerDebug');
  }
  return value;
};

debugMode._localStorageWrapper = function (action, key) {
  var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  try {
    return window.localStorage[action](key, value);
  } catch (error) {}
};